import { AppleUpdateEmail } from './AppleUpdateEmail.js';
export default AppleUpdateEmail;
//# sourceMappingURL=index.js.map